import { createSelector } from 'reselect';

const selectMasquerade = state => state.masquerade || {};

export const makeSelectMaquerade = () =>
  createSelector(selectMasquerade, state => {
    return state;
  });
